import { Button, Image, Text } from '@belong/ui';
import clsx from 'clsx';
import { useModal } from 'src/hooks/useModal';
import { SellHomeModal } from '../sell-home-modal/sell-home-modal';
import css from './sell-home-section.module.css';
import { SELL_HOME_SECTION_STRINGS } from './sell-home-section.strings';

export function SellHomeSection(): JSX.Element {
  const [isSellHomeModalOpen, openSellHomeModal, closeSellHomeModal] =
    useModal(false);
  return (
    <>
      <div
        className={clsx(
          'border-green px-sm pt-lg md:pl-lg md:pt-sm flex w-full flex-col items-center rounded border border-solid md:flex-row',
          css.sellHomeSectionContainer,
        )}
      >
        <div className={clsx('md:mr-sm', css.sellHomeSectionImage)}>
          <Image src="homeowner-lp/ho_lp_section_08.png" alt="" />
        </div>
        <div
          className={clsx(
            'mb-xl md:mb-sm flex flex-1 flex-col items-center text-center md:items-start md:text-left',
            css.sellHomeSectionContent,
          )}
        >
          <Text fontWeight="semibold" className="mb-2sm">
            {SELL_HOME_SECTION_STRINGS['sellHomeSection.title']}
          </Text>
          <Text className="mb-xs">
            {SELL_HOME_SECTION_STRINGS['sellHomeSection.body']}
          </Text>
          <Button variant="text" size="auto" onClick={openSellHomeModal}>
            {SELL_HOME_SECTION_STRINGS['sellHomeSection.ctaLabel']}
          </Button>
        </div>
      </div>
      <SellHomeModal
        onDismiss={closeSellHomeModal}
        isOpen={isSellHomeModalOpen}
      />
    </>
  );
}
